import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";
import { WhySection } from "@/components/WhySection";
import { WhoSection } from "@/components/WhoSection";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { PricingSection } from "@/components/PricingSection";
import { Footer } from "@/components/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="min-h-screen bg-[#F5ECD7]">
      {/* Fixed Header */}
      <Header />
      
      {/* Hero - Full viewport soothing video */}
      <HeroSection />
      
      {/* Why - Social cause, Reddit story */}
      <WhySection />
      
      {/* Who - Faiyaz and Azhar */}
      <WhoSection />

      {/* Testimonials - From before alongside existed */}
      <TestimonialsSection />
      
      {/* Pricing - Why we charge */}
      <PricingSection />
      
      <Footer />
    </main>
  );
}
